<template>
    <b-container fluid class="">
        <b-container class="p-4 dashboardTile shadow-lg">
            <b-row class="p-2">
                <b-col cols="12" lg="4">
                    <b-row class="py-2">
                        <b-col cols="12" class="text-center">
                            <h5>{{ $t('ticket_scan.search')}}</h5>
                        </b-col>
                    </b-row>
                    <b-row class="py-2 flex-center">
                        <b-form @submit.prevent="getTicket()" data-vv-scope="getTicket">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label-for="prefEvent">{{ $t('ticket_scan.select')}}
                                    <b-form-select v-model='event' id="prefEvent" name="prefEvent" ref="prefEvent" v-validate="'required|alpha_num'">
                                        <option v-for="event in events" :value="event.id">{{event.name}} - {{event.date_from| moment("DD.MM.YY.")}}</option>
                                    </b-form-select>
                                    <span class="vvError">{{ veeErrors.first('getTicket.prefEvent') }}</span>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <b-form-group class="label"
                                            label-for="ticketCode">
                                    <b-form-input v-validate="'required|max:13|min:5'" placeholder='Ticket code' v-model="scanCode" id="ticketCode" ref="ticketCode" type="text" size="md" name="ticketCode"></b-form-input>
                                    <span class="vvError">{{ veeErrors.first('getTicket.ticketCode') }}</span>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row >
                            <b-col cols="12">
                                <b-button class="float-right w-100" type="submit" variant="primary" :disabled="veeErrors.any('getTicket')" size="md" ref="btnChange"><i class="fa fa-barcode"></i> - {{ $t('ticket_scan.button')}}</b-button>
                            </b-col>
                        </b-row>

                    </b-form>
                    </b-row>
                </b-col>
                <b-col cols="12" lg="8" class="d-none d-md-block">
                    <b-row class="py-2">
                        <b-col cols="12" class="text-center">
                            <h5>{{ $t('ticket_scan.preview')}}</h5>
                        </b-col>
                    </b-row>
                    <b-row class="py-4">
                        <b-col cols="6">
                            <h4 class="mx-4 px-4">{{ticket.headline_a}}</h4>
                            <h5 class="mx-4 px-4">{{ticket.headline_b}}</h5>
                            <h6 class="mx-4 px-4">{{ticket.line_a}}</h6>
                            <h6 class="mx-4 px-4">{{ticket.line_b}}</h6>
                        </b-col>
                        <b-col cols="4" class="text-right">
                            <h6>{{$t('ticket_scan.sector')}}: {{ticket.sector}}</h6>
                            <h6>{{$t('ticket_scan.row')}}: {{ticket.number}}</h6>
                            <h6>{{$t('ticket_scan.seat')}}: {{ticket.seat_number}}</h6>
                        </b-col>

                        <b-col cols="2" class="text-right">
                            <b-img :src="require('../assets/img/barcode.png')" fluid alt="profile.png"/>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col cols="12" v-if="ticket.status">
                    <h6>{{ $t('ticket_scan.ticket')}} {{ticket.code}} {{ $t('ticket_scan.is')}} {{ticket.status}}</h6>
                </b-col>
            </b-row>
            </b-container>
        <hr>
        <b-row>
        <b-col cols="12"  v-for="log in logs">
            <b-col cols="12" sm="12" v-if="log.event_type=='error'">
                <b-alert variant="danger"   v-b-toggle="'accordion-'+log.id" show>
                    <b v-if="log.code"> Kod karte:{{log.code.substring(0, log.code.length - 6)}} {{log.code.substring(log.code.length - 6, log.code.length -1)}} {{log.code.substring(log.code.length - 1, log.code.length)}} - </b>{{log.event_msg}} na prolazu {{log.gate_id}}<i class="fa fa-chevron-down float-right"></i>
                    <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                        <b-card-text>{{log.msg_details}} </b-card-text>
                        
                        </b-card-body>
                    </b-collapse>
                    <footer class="blockquote-footer">
                        <a class="float-right" >{{log.created_at | moment("DD.MM.YY., HH:mm")}}</a>
                    </footer>
                </b-alert>  
            </b-col>
            <b-col cols="12" v-if="log.event_type=='info'">
                    <b-alert variant='info'   v-b-toggle="'accordion-'+log.id" show>
                    <b v-if="log.code"> Kod karte:{{log.code.substring(0, log.code.length - 6)}} {{log.code.substring(log.code.length - 6, log.code.length -1)}} {{log.code.substring(log.code.length - 1, log.code.length)}} - </b>{{log.event_msg}} na prolazu {{log.gate_id}}<i class="fa fa-chevron-down float-right"></i>
                    <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                        <b-card-text>{{log.msg_details}} </b-card-text>
                        
                        </b-card-body>
                    </b-collapse>
                    <footer class="blockquote-footer">
                        <a class="float-right" >{{log.created_at | moment("DD.MM.YY., HH:mm")}}</a>
                    </footer>
                </b-alert>  
            </b-col>
            <b-col cols="12" v-if="log.event_type=='warning'">
                    <b-alert variant="warning"   v-b-toggle="'accordion-'+log.id" show>
                    <b v-if="log.code"> Kod karte:{{log.code.substring(0, log.code.length - 6)}} {{log.code.substring(log.code.length - 6, log.code.length -1)}} {{log.code.substring(log.code.length - 1, log.code.length)}} - </b>{{log.event_msg}} na prolazu {{log.gate_id}}<i class="fa fa-chevron-down float-right"></i>
                    <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                        <b-card-text>{{log.msg_details}} </b-card-text>
                        
                        </b-card-body>
                    </b-collapse>
                    <footer class="blockquote-footer">
                        <a class="float-right" >{{log.created_at | moment("DD.MM.YY., HH:mm")}}</a>
                    </footer>
                </b-alert>  
            </b-col>
            <b-col cols="12" v-if="log.event_type=='success'">
                    <b-alert variant="success"   v-b-toggle="'accordion-'+log.id" show>
                    <b v-if="log.code"> Kod karte:{{log.code.substring(0, log.code.length - 6)}} {{log.code.substring(log.code.length - 6, log.code.length -1)}} {{log.code.substring(log.code.length - 1, log.code.length)}} - </b>{{log.event_msg}} na prolazu {{log.gate_id}}<i class="fa fa-chevron-down float-right"></i>
                    <b-collapse :id="'accordion-' + log.id" accordion="my-accordion" role="tabpanel">
                        <b-card-body>
                        <b-card-text>{{log.msg_details}} </b-card-text>
                        
                        </b-card-body>
                    </b-collapse>
                    <footer class="blockquote-footer">
                        <a class="float-right" >{{log.created_at | moment("DD.MM.YY., HH:mm")}}</a>
                    </footer>
                </b-alert>  
            </b-col>
        </b-col>
    </b-row>
    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'ticket-scan',
        data() {
            return {
                scanCode:'',
                events: {},
                event:'',
                logs:'',
                noTicket: ('toast.no'),
                printError: ('toast.printError'),
                ticket: {},
                ticketDef: {
                    headline_a:'Domaći',
                    headline_b:'Gosti',
                    line_a:'Vrijeme održavanja',
                    line_b:'Tip održavanja',
                    seat_number: '',
                    number: '',
                    sector: '', 
                    status: ''
                },
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            getEvents(){
                this.$axios.get('/events')
                .then(response => {
                    if(response.data.success) {
                        this.events = response.data.data;
                        this.event=this.events[0].id;
                    }
                });
            },
            getTicketLogs(){
                this.$axios.get('/eventTicketLogs',{
                    params: {
                        ticket_id: this.ticket.ticket_id
                    }
                }).then(result => {
                    if(result.data.success){
                        this.logs = result.data.data;
                    }
                })
            },
             getTicket(){
                this.$validator.validateAll('getTicket').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                       this.$axios.get('/scanTicket',
                            {
                                params: {
                                    event_id: this.event,
                                    code: this.scanCode,
                                }
                            }
                        ).then(response => {
                            if (response.data.success) {
                                if(response.data.data[0]!= undefined){
                                    this.ticket = response.data.data[0];
                                    this.getTicketLogs();
                                }else {
                                    this.ticket = this.ticketDef;
                                    this.logs = '';
                                    this.$toasted.global.err({
                                        message : this.$t(this.noTicket)
                                    });
                                }
                                
                            }
                            
                        }
                        ).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            }
        },

        created() {
            
            this.ticket=this.ticketDef;
            let self = this;
            this.getEvents();
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>
